// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 768px)";
var _3 = "wrapper-3vDmT";
var _4 = "toggle-1Hp97";
var _5 = "toggle__icon-2zg9A";
var _6 = "toggle__arrow-3ENdz";
var _7 = "toggle__text-3ej-e";
var _8 = "toggle__arrow_turned-1uRN-";
var _9 = "collapse-1bSgg";
var _a = "collapse__inner-2CQ1s";
var _b = "caption-2kzyK";
var _c = "filters-2wMvv";
var _d = "controls-3xEod";
var _e = "controls__cancel-1f2Pf";
var _f = "controls__confirm-rkOTj";
var _10 = "seats_count-2mCIa";
var _11 = "container-1qi-Q";
var _12 = "modal__top_wrapper-18Nh4";
var _13 = "modal__title-3ALXn";
var _14 = "modal__content-1BY_U";
var _15 = "controls__container-ofiGC";
var _16 = "show_button-14hWA";
var _17 = "title-38cve";
var _18 = "title__icon-154AO";
export { _1 as "__esModule", _2 as "tabletMiddle", _3 as "wrapper", _4 as "toggle", _5 as "toggle__icon", _6 as "toggle__arrow", _7 as "toggle__text", _8 as "toggle__arrow_turned", _9 as "collapse", _a as "collapse__inner", _b as "caption", _c as "filters", _d as "controls", _e as "controls__cancel", _f as "controls__confirm", _10 as "seats_count", _11 as "container", _12 as "modal__top_wrapper", _13 as "modal__title", _14 as "modal__content", _15 as "controls__container", _16 as "show_button", _17 as "title", _18 as "title__icon" }
export default { "__esModule": _1, "tabletMiddle": _2, "wrapper": _3, "toggle": _4, "toggle__icon": _5, "toggle__arrow": _6, "toggle__text": _7, "toggle__arrow_turned": _8, "collapse": _9, "collapse__inner": _a, "caption": _b, "filters": _c, "controls": _d, "controls__cancel": _e, "controls__confirm": _f, "seats_count": _10, "container": _11, "modal__top_wrapper": _12, "modal__title": _13, "modal__content": _14, "controls__container": _15, "show_button": _16, "title": _17, "title__icon": _18 }
